const typography = {
  MuiTypography: {
    /*
      subtitle1 y subtitle2 dejan de salir como <h6>.

      Ese es el mapeo por defecto de MUI, y es la causa de la mayoria de los
      saltos de nivel del sitio: un <h1> de titulo seguido de un <h6> que en
      realidad era el nombre de una tarjeta o el subtitulo de un bloque. Un
      subtitulo no es un encabezado de documento — es texto con un estilo — asi
      que <p> es lo correcto.

      Donde si toca que sea encabezado, el componente lo declara explicito con
      `component`, y eso siempre gana sobre este mapeo. Ver ToolContent.js y las
      tarjetas de guias relacionadas.

      Solo cambia la etiqueta; el aspecto lo sigue decidiendo variant.
    */
    defaultProps: {
      variantMapping: {
        subtitle1: 'p',
        subtitle2: 'p'
      }
    },
    styleOverrides: {
      gutterBottom: ({ theme }) => ({
        marginBottom: theme.spacing(2)
      })
    },
    variants: [
      {
        props: { variant: 'h1' },
        style: ({ theme }) => ({ color: theme.palette.text.primary })
      },
      {
        props: { variant: 'h2' },
        style: ({ theme }) => ({ color: theme.palette.text.primary })
      },
      {
        props: { variant: 'h3' },
        style: ({ theme }) => ({ color: theme.palette.text.primary })
      },
      {
        props: { variant: 'h4' },
        style: ({ theme }) => ({ color: theme.palette.text.primary })
      },
      {
        props: { variant: 'h5' },
        style: ({ theme }) => ({ color: theme.palette.text.primary })
      },
      {
        props: { variant: 'h6' },
        style: ({ theme }) => ({ color: theme.palette.text.primary })
      },
      {
        props: { variant: 'subtitle1' },
        style: ({ theme }) => ({ color: theme.palette.text.primary })
      },
      {
        props: { variant: 'subtitle2' },
        style: ({ theme }) => ({ color: theme.palette.text.secondary })
      },
      {
        props: { variant: 'body1' },
        style: ({ theme }) => ({ color: theme.palette.text.primary })
      },
      {
        props: { variant: 'body2' },
        style: ({ theme }) => ({ color: theme.palette.text.secondary })
      },
      {
        props: { variant: 'button' },
        style: ({ theme }) => ({ color: theme.palette.text.primary })
      },
      {
        props: { variant: 'caption' },
        style: ({ theme }) => ({ color: theme.palette.text.secondary })
      },
      {
        props: { variant: 'overline' },
        style: ({ theme }) => ({ color: theme.palette.text.secondary })
      }
    ]
  }
}

export default typography
